export const LS_AUTH = 'si:auth';
export const LS_AUTHTYPE = 'si:authtype';
export const LS_AUTHID = 'si:authid';
export const LS_AUTHINFO = 'si:authinfo';
export const LS_SEARCH_PARAMS = 'si:searchparams';
export const LS_AUTHCOMPANY = 'si:authcomp'; //tenant
export const LS_DEVICE = 'si:device';
/*** FUNNEL DATA **/
export const LS_FUNNELUSER = 'si:stamping';
/**
 * Verifica se il localStorage è disponibile e scrivibile.
 * Utile per gestire casi di navigazione in incognito restrittiva o disabilitazione manuale.
 */
export const isStorageAvailable = () => {
    //return false;
    try {
        const testKey = '__storage_test__';
        window.localStorage.setItem(testKey, testKey);
        window.localStorage.removeItem(testKey);
        return true;
    }
    catch (e) {
        return false;
    }
};
// Se il localStorage non è disponibile, usiamo un oggetto vuoto per evitare crash
// Ma l'applicazione dovrebbe comunque mostrare il fallback UI all'avvio.
const __storage = isStorageAvailable() ? window.localStorage : {
    setItem: () => { },
    getItem: () => null,
    removeItem: () => { },
    clear: () => { }
};
export const setLocalStorage = (key, value) => {
    __storage.setItem(key, value);
};
export const getLocalStorage = (key) => __storage.getItem(key);
export const removeFromLocalStorage = (key) => {
    __storage.removeItem(key);
};
/**
 * Pulisce tutti i dati relativi all'autenticazione e alla sessione utente.
 */
export const clearAuthStorage = () => {
    removeFromLocalStorage(LS_AUTH);
    removeFromLocalStorage(LS_AUTHTYPE);
    removeFromLocalStorage(LS_AUTHID);
    removeFromLocalStorage(LS_AUTHINFO);
    removeFromLocalStorage(LS_AUTHCOMPANY);
    removeFromLocalStorage(LS_SEARCH_PARAMS);
    removeFromLocalStorage(LS_DEVICE);
    removeFromLocalStorage(LS_FUNNELUSER);
};
export const clearLocalStorage = () => {
    __storage.clear();
};
